module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/logo-aoj-en-c46ef754b53e69d1d16f75a8b9aeac3e.svg";